import "./About.module.css";
import Header from "@/reusable_sections/Header";
import Mission from "./sections/Mission";
import History from "./sections/History";
import Leadership from "./sections/Leadership";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <Mission />
      <History />
      <Leadership />
      <Footer />
    </div>;
}